export default {
    data: () => ({
        translations: {
            addCategory: {
                el: "Προσθήκη Κατηγορίας Προϊόντων",
                en: "Add Category",
                it: "Aggiungere una categoria di prodotti"
            },
            nameInGreek: {
                el: "Όνομα στα Ελληνικά",
                en: "Name in Greek",
                it: "Nome in greco"
            },
            nameInEnglish: {
                el: "Όνομα στα Αγγλικά",
                en: "Name in English",
                it: "Nome in inglese"
            },
            nameInItalian: {
                el: "Όνομα στα Ιταλικά",
                en: "Name in Italian",
                it: "Nome in italiano"
            },
            actions: {
                el: "Ενέργεια",
                en: "Actions",
                it: "Azioni"
            },
            noData: {
                el: "Δεν υπάρχουν δεδομένα",
                en: "No data available",
                it: "Nessun dato disponibile"
            },
            update: {
                el: "Ενημέρωση",
                en: "Update",
                it: "Aggiornamento"
            },
            delete: {
                el: "Διαγραφή",
                en: "Delete",
                it: "Cancellare"
            },
            deleteCategory: {
                el: "",
                en: "Delete Product Category",
                it: ""
            },
            areYouSure: {
                el: "",
                en: "Are you sure you want to delete",
                it: ""
            },
            paginationText: {
                el: "από",
                en: "of",
                it: "di"
            }
        }
    })
};
